const config = {
  defaultLocale: 'en'
}

export default config
